import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import NestedFormController from "./controllers/nested_form_controller"

const application = Application.start()
application.debug = false
application.register("nested-form", NestedFormController)
;(window as any).Stimulus = application

export { application }
